"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDateItemLabelClasses = exports.useDateItemClasses = void 0;
var classnames_1 = require("classnames");
var theme_1 = require("../../theme");
var dateItemBaseClass = "\n  squid-w-[40px]\n  squid-h-[40px]\n  squid-rounded-full\n  squid-select-none\n  squid-flex\n  squid-justify-center\n  squid-items-center\n";
var useDateItemClasses = function (_a) {
    var pressed = _a.pressed, disabled = _a.disabled, current = _a.current, active = _a.active;
    var bgColors = (0, theme_1.useBackgroundColors)();
    var borderColors = (0, theme_1.useBorderColors)();
    var backgroundColor = active ? bgColors.primary : bgColors.base;
    var borderColor = current ? borderColors.active : borderColors.base;
    return (0, classnames_1.default)(dateItemBaseClass, {
        'hover:squid-cursor-default': disabled,
        'hover:squid-cursor-pointer': !disabled,
        'hover:squid-bg-alias-state-base-pressed': pressed && !disabled,
        'hover:squid-bg-alias-state-base-hover': !pressed && !active && !disabled,
        'squid-border-[1.5px]': current,
    }, backgroundColor, borderColor, 'squid-justify-self-center');
};
exports.useDateItemClasses = useDateItemClasses;
var useDateItemLabelClasses = function (_a) {
    var disabled = _a.disabled, current = _a.current, active = _a.active;
    var textColors = (0, theme_1.useTextColors)();
    if (disabled) {
        return (0, classnames_1.default)(textColors.disabled);
    }
    else if (!disabled && current && !active) {
        return (0, classnames_1.default)(textColors.base);
    }
    else if (!disabled && active) {
        return (0, classnames_1.default)(textColors['on-primary']);
    }
    else if (!disabled && !active) {
        return (0, classnames_1.default)(textColors.weak);
    }
    return (0, classnames_1.default)(textColors.base);
};
exports.useDateItemLabelClasses = useDateItemLabelClasses;
